import Vue from 'vue'
import 'babel-polyfill';

import 'swiper/css/swiper.css'
import VueAwesomeSwiper from "vue-awesome-swiper";
import '@/assets/style/index.less' // global css

import App from './App'
import router from './router'

import '@/progress' //页面加载进度条

import message from "@/components/message";
import page from "@/components/page";

import store from './store';
import language from './language';
import pcmobile from './pcmobile';

Date.prototype.Format = function (fmt) {
  var o = {
  "M+": this.getMonth() + 1, //月份
  "d+": this.getDate(), //日
  "H+": this.getHours(), //小时
  "m+": this.getMinutes(), //分
  "s+": this.getSeconds(), //秒
  "q+": Math.floor((this.getMonth() + 3) / 3), //季度
  "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
function resizeHandel(){
  store.state.width=window.innerWidth || document.documentElement.clientWidth;
}
window.addEventListener('resize', resizeHandel); //实时会影响性能
resizeHandel();

import { VueMasonryPlugin } from "vue-masonry";
Vue.use(VueMasonryPlugin);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$language = language;
Vue.prototype.$pcmobile = pcmobile;
Vue.prototype.$color = "white";
Vue.prototype.$message = message;
Vue.prototype.$page = page;
Vue.prototype.$vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

// Vue.prototype.$EventBus = new Vue();





// WEBPACK FOOTER //
// ./src/main.js